import { reactive, computed, ref, watch } from '@vue/composition-api';
import { useCouponInfo } from './use-channel-coupon';
import { useGuideDriver } from '@/hooks/use-guide-driver';
import { ensureChannelCouponId } from '@/utils/channel-coupon';

/**
 * 目前支持的渠道key，值为url里面的param key，url中的值为couponId
 */
export enum ChannelKey {
  /**
     * 线下扫码领取专属优惠券
     */
  ScanForPerks = 'scanforperks',
};

const showConfig = reactive({
  [ChannelKey.ScanForPerks]: false,
});

/**
 * 在弹窗管理器中使用，用以决定是否要展示渠道券弹窗
 * @returns
 */
export function useChannelCouponDialog() {
  const showDialog = (key: ChannelKey) => {
    showConfig[key] = true;
  };
  const hideDialog = (key: ChannelKey) => {
    showConfig[key] = false;
  };
  const isShowDialog = (key: ChannelKey) => showConfig[key];
  const isNeedShowDialog = (key: ChannelKey) => {
    const couponId = ensureChannelCouponId(key);
    const couponInfo = useCouponInfo(couponId);
    return !!couponInfo.value;
  };

  return {
    showDialog,
    hideDialog,
    isShowDialog,
    isNeedShowDialog,
  };
}

/**
 * 新用户弹窗状态来决定是否展示活动弹层
 */
export function useShowByNewUserState() {
  const { showConfig } = useGuideDriver();
  const isShow = computed(() => showConfig.isShow);
  const isNeedShow = computed(() => showConfig.isNeedShow);

  const hasShown = ref(false);

  watch(isShow, () => {
    if (isShow.value) {
      hasShown.value = true;
    }
  });

  /**
     * state 表示是否允许展示渠道活动弹层
     */
  const state = computed(() => {
    // 不需要展示新用户引导的，直接展示活动弹层
    if (!isNeedShow.value) {
      return true;
    }

    // 新用户弹窗已经展示过，且当前是关闭状态，此时可以展示活动弹层
    if (hasShown.value && !isShow.value) {
      return true;
    }

    return false;
  });

  return state;
}
